module.exports = __webpack_public_path__ + "static/media/sShip1.458caf19.png";